import type React from "react";
import {useParams} from "react-router-dom";

import {useLevelV2} from "~/api/hooks/useLevelV2";

import GameContainer from "../../../component/game/GameContainer";
import CameraControlsDuringPlay from "../../../three/camera/CameraControlsDuringPlay";
import DeathExplosion from "../../../three/effects/DeathExplosion";
import GoalExplosion from "../../../three/effects/GoalExplosion";
import ImpulseEffect from "../../../three/effects/ImpulseEffect";
import ParticleTrails from "../../../three/effects/ParticleTrails";
import ShardCollectedAnimation from "../../../three/effects/ShardCollectedAnimation";
import Players from "../../../three/player/Players";
import type {PlayLevelParams} from "./PlayLevelParams";

const PlayLevelR3F: React.FC = () => {
  const {id} = useParams<PlayLevelParams>();
  const {data: level} = useLevelV2({id});
  return (
    <>
      {level && <GameContainer id={level.id} levelData={level.data} />}
      <CameraControlsDuringPlay following={true} />
      <Players />
      <ImpulseEffect />
      <ParticleTrails />
      <GoalExplosion />
      <DeathExplosion />
      <ShardCollectedAnimation />
    </>
  );
};

export default PlayLevelR3F;
